import React from 'react'
import './containers.css'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Filter from '../Filter/Filter'
import { useLocation } from 'react-router-dom'

const MainContainer: React.FunctionComponent<any> = ({ children }) => {

  const location = useLocation()

  /** Add more routes to show filter option */
  const Marketplace: Array<string> = ['/marketplace', '/api-listing/production', '/api-listing/live']
  
  return (
    <section className='main-wrapper d-flex flex-column justify-content-between'>
        <div className='header-filter-container'>
          <Header />
          {
            Marketplace.includes(location.pathname) &&
            <Filter />
          }
          <div className="mf-main-content-spacer">{ children }</div>
        </div>
        <Footer />
    </section>
  )
}

export default MainContainer